import React, { Component, useState } from 'react';
import { Link } from 'react-router-dom';

// ========== ELEMENTS ==========
import Loader from '../elements/Loader';
import NavBar from '../parts/NavBar';
import Footer from '../parts/Footer';

// ========== SCSS ==========
import '../scss/login.scss';

export class PasswordReset extends Component {
  constructor(props) {
    super(props);
    this.state = {
      old_password: '',
      new_password: '',
      new_password_c: ''
    };
  }

  handleChange(e) {
    const value = e.target.value;
    this.setState({
      ...this.state,
      [e.target.name]: value
    });
  }

  async formSubmit(e) {
    e.preventDefault();

    if (this.state.new_password == this.state.new_password_c) {

      let response = await window.doRequest('POST', {
        action: 'resetPassword',
        token: sessionStorage.getItem('token'),
        old_password: this.state.old_password,
        new_password: this.state.new_password
      });

      if (response.status) {
        window.alert('Senha atualizada!');
        this.props.history.push('/states');
      } else
          window.alert(response.message);

    } else {
      window.alert('A confirmação e a nova senha devem ser iguais!');
    }
  }

  render() {
    return (
      <main>
        <NavBar />
        <section id="login">
          <div className="container password-recovery">
            <h1 className="title">Alteração de senha</h1>
            <p>Preencha os dados abaixo.</p>
            <form onSubmit={(e) => { this.formSubmit(e) }}>

              <input
                type="password"
                placeholder="Senha atual"
                name="old_password"
                value={this.state.old_password}
                onChange={(e) => {this.handleChange(e)}}
                required>
              </input>

              <input
                type="password"
                placeholder="Nova senha"
                name="new_password"
                value={this.state.new_password}
                onChange={(e) => {this.handleChange(e)}}
                required>
              </input>

              <input
                type="password"
                placeholder="Confirmação de senha"
                name="new_password_c"
                value={this.state.new_password_c}
                onChange={(e) => {this.handleChange(e)}}
                required>
              </input>

              <div className="btn-container">
                <button className="btn filled" type="submit">Salvar</button>
              </div>

            </form>
          </div>
        </section>
        <Footer />
      </main>
    );
  }
}

export default PasswordReset
